import React from 'react';
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import './BannerComponent.scss'

class BannerComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			len: props.len,
			swiperId: props.name || 'swiper-container',
			showList: false
		};
	}

	UNSAFE_componentWillMount() {
		this.bannerSwiper = null
		setTimeout(() => {
			this.bannerSwiper = new Swiper('.swiper-container1', {
				slidesPerView: 5.5,
				spaceBetween: -5
			});
		}, 500)
	}

	changeNext = (type) => {
		if (!this.bannerSwiper) return
		if (type === 'left') {
			this.bannerSwiper.slidePrev();
		} else {
			this.bannerSwiper.slideNext();
		}
	}

	render() {
		const swiperArr = [1, 2, 3, 4, 5, 6, 7, 8, 9]
		const swiperImgArr = [
			require('../../asstes/img/other/red-list/red-list1.png'),
			require('../../asstes/img/other/red-list/red-list2.png'),
			require('../../asstes/img/other/red-list/red-list3.png'),
			require('../../asstes/img/other/red-list/red-list4.png'),
			require('../../asstes/img/other/red-list/red-list5.png'),
			require('../../asstes/img/other/red-list/red-list6.png'),
			require('../../asstes/img/other/red-list/red-list7.png'),
			require('../../asstes/img/other/red-list/red-list8.png'),
			require('../../asstes/img/other/red-list/red-list9.png'),
		]
		const shadow = require('../../asstes/img/other/red-list/red-list-right-shadow.png')
		const leftArrow = require('../../asstes/img/other/banner-arrow-left.png')
		const rightArrow = require('../../asstes/img/other/banner-arrow-right.png')

		return (<div className="banner-container">
			<div className="swiper-container1" id={'swiper-container1'}>
        {
          swiperArr.length === 0 ? null :
            <div className="swiper-wrapper">
              {
	              swiperArr.map((item, idx) => {
                  return <div className="swiper-slide banner-swiper-slide" key={idx}>
                    <img src={swiperImgArr[idx]} alt="/"/>
                  </div>
                })
              }
            </div>
        }
        {/* 图形右侧阴影 */}
				<img className="right-shadow" src={shadow} alt=""/>
			</div>
			<img className="left-arrow" onClick={() => this.changeNext('left')} src={leftArrow} alt=""/>
			<img className="right-arrow" onClick={() => this.changeNext('right')} src={rightArrow} alt=""/>
		</div>)
	}
}

export default BannerComponent;
